module.exports = __webpack_public_path__ + "static/fonts/Poppins-ExtraLightItalic.a9bed01.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Poppins-ExtraLightItalic.ttf
// module id = 1024
// module chunks = 11